import React from 'react';

function Homepage({ onStartRegistration }) {
  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="scanline"></div>
      <div className="max-w-md w-full">
        <div className="bg-dark-lighter/95 backdrop-blur-sm rounded-lg shadow-neon-green border border-primary/30 p-8">
          {/* Header with Glitch Effect */}
          <div className="text-center mb-6">
            <div className="text-6xl mb-4 glitch">⚠️</div>
            <h1 className="text-4xl font-bold text-primary mb-2 font-mono glitch tracking-wider">
              CODE RACE
            </h1>
            <p className="text-lg text-cyber-red font-mono">
              [SYSTEM BREACH DETECTED]
            </p>
          </div>

          {/* Terminal-style Breach Animation */}
          <div className="bg-dark border border-cyber-blue/50 p-4 rounded-lg mb-6 font-mono text-sm">
            <div className="text-cyber-blue mb-1">&gt; Breaching 0%</div>
            <div className="text-cyber-blue mb-1">&gt; Breaching 32%</div>
            <div className="text-cyber-blue mb-1">&gt; Breaching 89%</div>
            <div className="text-primary mb-1">&gt; Breaching done</div>
            <div className="text-primary mb-1">&gt; Coderace begin</div>
            <div className="text-cyber-red blink">&gt; Escape will make me god</div>
          </div>

          {/* Mission Brief - Concise */}
          <div className="bg-dark border border-primary/50 p-4 rounded-lg mb-6">
            <ul className="text-matrix-green space-y-2 text-sm font-mono">
              <li>→ Scan QR codes to start</li>
              <li>→ Navigate to your target</li>
              <li>→ Beat the timer</li>
              <li>→ Vote for a theme</li>
            </ul>
          </div>

          {/* CTA Button */}
          <button
            onClick={onStartRegistration}
            className="w-full bg-primary text-dark text-xl font-bold font-mono
                     px-8 py-4 rounded-lg hover:shadow-neon-green transform hover:scale-105 
                     transition-all duration-200 border-2 border-primary
                     hover:bg-transparent hover:text-primary"
          >
            [INITIALIZE] →
          </button>
        </div>
      </div>
    </div>
  );
}

export default Homepage;
